interface PaginationArgs {
  pagination?: {
    offset?: number;
  };
}

// Reimplementation of offsetLimitPagination from @apollo/client/utilities, but with different arguments
export const offsetLimitPagination = <T>(
  existing: T[] | undefined,
  incoming: T[] | undefined,
  args?: PaginationArgs
): T[] => {
  const merged = existing ? existing.slice(0) : [];

  if (incoming) {
    if (args?.pagination) {
      const { offset = 0 } = args.pagination;
      for (let i = 0; i < incoming.length; i += 1) {
        merged[offset + i] = incoming[i];
      }
    } else {
      return incoming;
    }
  }

  return merged;
};
